export default __webpack_public_path__ + "static/intelligence-solution-1344ea3a85e5bbe45c7805873cd7f6ff.png";